export { default as PrimaryLarge } from '@/assets/graphics/splashes/primary-large.svg';
export { default as PrimarySmall } from '@/assets/graphics/splashes/primary-small.svg';
export { default as SecondaryLarge } from '@/assets/graphics/splashes/secondary-large.svg';
export { default as SecondarySmall } from '@/assets/graphics/splashes/secondary-small.svg';

export type Theme = 'primary' | 'secondary';
